<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Lista de Series de Cargos</h5>
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <router-link
                class="btn btn-sm btn-success"
                :to="{ name: 'cxc-cargo-serie-nuevo', params: {}}"
              >
                <i class="fa fa-plus"></i>
                Nuevo Cargo Serie
              </router-link>
              <a class href="#"></a>
              <a
                v-if="mostrarRefresh"
                class="btn btn-sm btn-info"
                @click="refreshData"
                href="#"
              >Refresh</a>
            </div>
            <div class="col-sm-6">
              <form action="#" class="form-inline justify-content-sm-end">
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                />
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="button" @click="filterData">
                    <i class="fa fa-search"></i>
                  </button>
                  <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filterActive"
                  @click="filterData"
                >
                  <option value="null">Todos</option>
                  <option value="1">Activo</option>
                  <option value="0">Inactivo</option>
                </select>
              </form>
                </div>
                <br>
              <div  align="right">
              <form action="#" class="form-inline justify-content-sm-end">
              <div class="input-group-append">
              <label><small>Filtro Tipo Cargo</small></label>
              <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData">
              <i class="fa fa-times"></i>
              </button>
              <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filterCargo"
                  @change="refreshCargo"
                  @click="filterData"
                >
                <option
                  v-for="(c, key) in cargos"
                  :value="c.id"
                  :key="key"
                >{{ c.nombre }}</option>
                </select>
                </div>
              </form>
              </div>
          </div>
        </div>

        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="table-responsive">
          <!-------------------- Tabla de REsultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th scope="col" class="text-center" >Serie</th>
                <th scope="col" class="text-center">Tienda</th>
                <th scope="col" class="text-center">Tipo Cargo</th>
                <th scope="col" class="text-center">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="current in data.results" v-bind:key="current.id">
                <td scope="row" class="text-center" >{{ current.serie }}</td>
                <td class="text-center" >{{ current.tienda.nombre }}</td>
                <td class="text-center" >{{ current.cxc_tipo_cargo.nombre }}</td>
                <td class="text-center">
                  <div
                    v-if="current.estado"
                    class="status-pill green"
                    data-title="Activo"
                    data-toggle="tooltip"
                  ></div>
                  <div
                    v-if="!current.estado"
                    class="status-pill red"
                    data-title="Inactiva"
                    data-toggle="tooltip"
                  ></div>
                </td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent :currentPage="currentPage" :data="data" @pagechanged="onPageChange" />
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import PaginationComponent from "@/components/utils/PaginationComponent";
import CargoSerieService from "@/services/cxc/CargoSerieService";


export default {
  components: {
    PaginationComponent
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filterCargo: 1,
      filterActive: 1,
      data: []
    };
  },
  computed: {
    ...mapGetters({
      cargos: "cargos/tipocargo"
    }),
  },
  mounted() {
    if (this.$route.params.id) {
      CargoSerieService.getById(this.$route.params.id).then(response => {
        this.current = response.data;
        this.current.errors = [];
        this.current.id
    });
  }
  this.refreshCargo();
  this.clearFilterData();
  },
  methods: {
    refreshCargo() {
      let self = this;
      self.$store.dispatch("cargos/tipocargo", {
        quitar_paginacion: true
      });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        cxc_tipo_cargo: this.filterCargo,
        estado: this.filterActive,
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        cxc_tipo_cargo: this.filterCargo,
        estado: this.filterActive,
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterCargo = null;
      this.filterActive = null;
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        cxc_tipo_cargo: this.filterCargo,
        estado: this.filterActive,
      });
    },
    hide: function() {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      CargoSerieService.fetch(params).then(res => {
        self.data = res.data;
      });
    },
      rowClick(current) {
      let self = this;
      self.$router.push({
        name: "cxc-cargo-serie-editar",
        params: { id: current.serie }
      });
    },
    showModalEdit() {}
  }
};
</script>
